import CoinBaseApi from './base'
import { WalletCoin, CoinBasis, GetVaultCoinListDTO, ToggleCoinDTO } from './models'

class CoinApi extends CoinBaseApi {
  async getVaultCoinList(dto: GetVaultCoinListDTO) {
    return this.post<WalletCoin[]>('/getVaultCoinList', dto)
  }

  async getBasicCoinList() {
    return this.post<CoinBasis[]>('/getAllCoinList')
  }

  async toggleWalletCoin(dto: ToggleCoinDTO) {
    return this.post<boolean>('/accountCoinSwitch', dto)
  }
}

export default new CoinApi()
